import { ReactNode, useRef, useState } from 'react';
import { Popover } from '@mews/b2b-ui';
import { lt } from '@mews/framework';
import { Position, Stack, Typography } from '@optimus-web/core';
import { MoreItemsLink } from './MoreItemsLink';

interface GuestClassificationsPopover {
    linkCount: number;
    classifications: ReactNode[];
}

export const GuestClassificationsPopover = ({ linkCount, classifications }: GuestClassificationsPopover) => {
    const [active, setActive] = useState(false);
    const elementRef = useRef<HTMLAnchorElement | null>(null);

    return (
        <>
            <MoreItemsLink elementRef={elementRef} count={linkCount} onClick={() => setActive(!active)} />
            <Popover
                position={Position.Bottom}
                active={active}
                anchorElement={elementRef.current}
                title={lt('Classifications')}
                onClose={() => setActive(false)}
            >
                <Typography textStyle="bodySmall" variant="secondary" as="div">
                    <Stack vertical spacing="100" itemAlignment="start">
                        {classifications}
                    </Stack>
                </Typography>
            </Popover>
        </>
    );
};
